import type { App } from 'vue'
import { savePromotionExposure } from '@/api/promotionBehavior'
import { prepareRequestAuth } from '@/interceptors/request'
import { browserChannelId, useChannelStore } from '@/store/channel'

async function reportExposure(channelId: string) {
  try {
    const token = await prepareRequestAuth('tokenHK')
    const response = await savePromotionExposure(channelId, Boolean(token))
    if (!response.success)
      console.warn('[channel] exposure rejected:', response.msg)
  }
  catch (error) {
    // 埋点失败不能阻断页面进入、跳转和支付。
    console.warn('[channel] exposure failed:', error)
  }
}

export const channelInterceptor = {
  install(app: App) {
    const pageChannels = new WeakMap<object, string>()
    app.mixin({
      onLoad(options: Record<string, unknown> = {}) {
        const store = useChannelStore()
        const channelId = typeof options.channelId === 'string'
          ? options.channelId
          : store.initialized ? store.channelId : browserChannelId() ?? ''
        pageChannels.set(this, channelId)
        store.channelId = channelId
        store.initialized = true
      },
      onShow() {
        // App/普通组件不参与曝光；只有执行过 onLoad 的页面参与。
        if (!pageChannels.has(this))
          return
        const store = useChannelStore()
        const pages = getCurrentPages()
        const route = pages[pages.length - 1]?.route || ''
        if (store.pendingTab?.path === `/${route.replace(/^\//, '')}`) {
          pageChannels.set(this, store.pendingTab.channelId)
          store.pendingTab = null
        }
        const channelId = pageChannels.get(this) ?? ''
        store.channelId = channelId
        store.initialized = true
        if (channelId)
          void reportExposure(channelId)
      },
    })
  },
}
